import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Select,
  Popconfirm,
  message,
  Modal,
  Spin,
  Space,
  Table,
  Typography
} from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { request } from "../services/api";
import { AppContext } from "../context/AppContext";

const { Title, Text } = Typography;
const { TextArea } = Input;

const LevelTwo = () => {
  const {
    levelOneOptions,
    // eslint-disable-next-line
    setLevelOneOptions,
    // eslint-disable-next-line
    levelTwoOptions,
    setLevelTwoOptions
  } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [nextOption, setNextOption] = useState(0);
  const [optionLevelOne, setOptionLevelOne] = useState(0);
  const [isIntentChange, setIsIntentChange] = useState(false);
  const [isSearchTable, setIsSearchTable] = useState(false);
  const [isFulfilment, setIsFulfilment] = useState(false);

  const [modalMode, setModalMode] = useState("create");
  const [currentRecord, setCurrentRecord] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const onLevelOneChange = (value) => {
    if (value > 0) {
      start(value);
    }
    setOptionLevelOne(value);
  };

  const onActionChange = (value) => {
    if (value !== "") {
      console.log(value);
      console.log("reset");
      setIsIntentChange(false);
      setIsFulfilment(false);
      setIsSearchTable(false);
      switch (value) {
        case "transferToIntent":
          setIsIntentChange(true);
          break;
        case "fulfilIntent":
          setIsFulfilment(true);
          break;
        case "searchTable":
          setIsSearchTable(true);
          break;
        default:
      }
    }
  };

  const openCreateModal = () => {
    setModalMode("create");
    setCurrentRecord(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const openEditModal = (record) => {
    setIsFulfilment(false);
    setModalMode("edit");
    setCurrentRecord(record);
    form.setFieldsValue(record);
    setIsModalOpen(true);
    if (record.action === "fulfilIntent") {
      setIsFulfilment(true);
    }
  };

  useEffect(() => {
    if (nextOption) {
      form.setFieldsValue({
        optionLevelTwo: nextOption
      });
    }
  }, [isModalOpen, nextOption, form]);

  const renameKeyInArray = async (arr, oldKey, newKey) => {
    return arr.map((obj) => {
      const { [oldKey]: oldValue, ...rest } = obj;
      return {
        ...rest,
        [newKey]: oldValue
      };
    });
  };

  const start = async (value) => {
    try {
      if (value) {
        form.setFieldsValue({
          optionLevelOne: value
        });
      }
      const params = `optionLevelOne=${value}`;
      setLoading(true);
      const response = await request(`/management/two/retrieve?${params}`, {
        method: "GET"
      });
      const indexedData = response.map((item, index) => ({
        ...item,
        key: item.id || index
      }));
      if (indexedData.length === 0) {
        console.log("first option", Number(`${value}${1}`));
        setNextOption(Number(`${value}${1}`));
      } else {
        console.log("next option", Number(String(indexedData[indexedData.length - 1]?.optionLevelOne)+ String(indexedData.length + 1)))
        //setNextOption(indexedData[indexedData.length - 1]?.optionLevelTwo + 1);
        setNextOption(Number(String(indexedData[indexedData.length - 1]?.optionLevelOne)+ String(indexedData.length + 1)));
      }
      setData(indexedData);

      if (response.length > 0) {
        const menuOptionsLevelTwoValues = await renameKeyInArray(
          response,
          "optionLevelTwo",
          "value"
        );
        const menuOptionsLevelTwoLabels = await renameKeyInArray(
          menuOptionsLevelTwoValues,
          "name",
          "label"
        );
        const safeOptions = menuOptionsLevelTwoLabels.map(
          ({ action, ...rest }) => ({
            ...rest,
            intentAction: action
          })
        );
        setLevelTwoOptions(safeOptions);
      }
    } catch (error) {
      messageApi.error("No se pudo iniciar la consulta");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (values) => {
    console.log("tocreate", values);
    try {
      setLoading(true);
      let datosAEnviar = { ...values };
      console.log(datosAEnviar);
      await request("/management/two/create", {
        method: "POST",
        body: JSON.stringify(datosAEnviar)
      });
      messageApi.success(`Registro creado`);
      setIsModalOpen(false);
      form.resetFields();
      start(optionLevelOne);
    } catch (error) {
      messageApi.error("Error al crear contacto");
      console.log("option cannot be added");
    } finally {
      setLoading(false);
      console.log("option added successfully");
    }
  };

  const removeAndResequence = (arr, removedValue) => {
    return arr
      .filter((item) => item.optionLevelTwo !== removedValue)
      .map((item) => {
        if (item.optionLevelTwo > removedValue) {
          return { ...item, optionLevelTwo: item.optionLevelTwo - 1 };
        }
        return item;
      });
  };

  const getItemsToUpdateAfterRemoval = (
    arr,
    removedValue,
    field = "optionLevelTwo"
  ) => {
    return arr
      .filter((item) => item?.[field] > removedValue)
      .map((item) => ({
        ...item,
        previousLevelTwo: item[field], // valor antes del ajuste
        [field]: item[field] - 1 // nuevo valor a guardar
      }));
  };

  const handleDelete = async (recordAEliminar) => {
    const { optionLevelTwo } = recordAEliminar;
    console.log("optionLevelTwo Item removed", optionLevelTwo);
    try {
      setLoading(true);
      await request(
        `/management/two/remove?optionLevelTwo=${Number(optionLevelTwo)}&optionLevelOne=${Number(optionLevelOne)}`,
        {
          method: "DELETE"
        }
      );
      // eslint-disable-next-line
      const newData = removeAndResequence(data, optionLevelTwo);
      const dataToUpdate = getItemsToUpdateAfterRemoval(data, optionLevelTwo);
      if (dataToUpdate.length > 0) {
        await request("/management/two/sort", {
          method: "PATCH",
          body: JSON.stringify(dataToUpdate)
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.error("No se pudo eliminar");
    } finally {
      setLoading(false);
      console.log("option removed successfully");
      start(optionLevelOne);
    }
  };

  const handleUpdate = async (recordAActualizar) => {
    try {
      delete recordAActualizar.key;
      setLoading(true);
      await request("/management/two/update", {
        method: "PATCH",
        body: JSON.stringify(recordAActualizar)
      });
    } catch (error) {
      messageApi.error("No se pudo actualizr");
    } finally {
      setLoading(false);
      console.log("option updated successfully");
      start(optionLevelOne);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (modalMode === "create") {
        await handleCreate(values);
      } else {
        const { optionLevelOne, optionLevelTwo, ...newCurrentRecord } = values;
        const newValues = { ...currentRecord, ...newCurrentRecord };
        await handleUpdate(newValues);
      }
      setIsModalOpen(false);
      form.resetFields();
    } catch (err) {}
  };

  const columns = [
    {
      title: "Posición",
      dataIndex: "optionLevelTwo",
      key: "optionLevelTwo",
      width: 100
    },
    { title: "Nombre", dataIndex: "name", key: "name" },
    { title: "Acción", dataIndex: "action", key: "action", width: 200 },
    { title: "Intención", dataIndex: "intent", key: "intent", width: 200 },
    { title: "Modelo", dataIndex: "model", key: "model", width: 200 },
    { title: "Mensaje", dataIndex: "message", key: "message" },
    { title: "Tabla", dataIndex: "table", key: "table" },
    {
      title: "Actividades",
      key: "remover",
      fixed: "right",
      width: 110,
      render: (_, record) => {
        const isDeleteDisabled = record.action === "none";

        return (
          <Space size="middle">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
            />
            <Popconfirm
              title="Eliminar opción de menú"
              description={`¿Estás seguro de que deseas eliminar esta opción?, todas las dependencias serán eliminadas también`}
              onConfirm={() => handleDelete(record)}
              okText="Sí, eliminar"
              cancelText="No"
              okButtonProps={{ danger: true }}
              disabled={isDeleteDisabled}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                disabled={isDeleteDisabled}
              />
            </Popconfirm>
          </Space>
        );
      }
    }
  ];

  return (
    <div>
      {contextHolder}
      <div style={{ marginBottom: 32 }}>
        <Title level={2} style={{ margin: 0 }}>
          Menú secundario
        </Title>
        <Text type="secondary">
          Alta y baja de las opciones del menú secundario.
        </Text>
        <br />
        <Space style={{ marginTop: 16, marginBottom: 16 }}>
          <Select
            style={{ width: "200px" }}
            placeholder="Selecciona primer nivel"
            onChange={onLevelOneChange}
            options={levelOneOptions}
          />
          {optionLevelOne > 0 ? (
            <Button
              icon={<PlusOutlined />}
              onClick={() => openCreateModal(true)}
            >
              Nueva Opción
            </Button>
          ) : (
            <Button
              disabled
              icon={<PlusOutlined />}
              onClick={() => openCreateModal(true)}
            >
              Nueva Opción
            </Button>
          )}
        </Space>
        <Card>
          <Spin spinning={loading} description="Cargando información...">
            <Table
              dataSource={data}
              columns={columns}
              rowKey="label"
              pagination={false}
              tableLayout="fixed"
            />
          </Spin>
        </Card>
        <Modal
          title={modalMode === "create" ? "Nuevo registro" : "Editar registro"}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            form.resetFields();
          }}
          onOk={() => form.submit()}
          confirmLoading={loading}
          okText="Guardar"
          cancelText="Cancelar"
          updateText="Actualizar"
          okButtonProps={{ style: { background: "#000" } }}
          forceRender={true}
          destroyOnHidden
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{
              optionLevelOne: optionLevelOne
            }}
          >
            <Form.Item
              name="optionLevelOne"
              label="Categoría principal"
              rules={[
                { required: false, message: "Ingresa la categoría principal" }
              ]}
            >
              <Input
                placeholder="ejemplo: Atención a clientes"
                style={{ width: "70px" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="optionLevelTwo"
              label="Posición"
              rules={[
                { required: true, message: "Ingresa la posición de la opción" }
              ]}
            >
              <Input
                placeholder="ejemplo: Atención a clientes"
                style={{ width: "70px" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Nombre"
              rules={[
                { required: true, message: "Ingresa el nombre de la opción" }
              ]}
            >
              <Input placeholder="ejemplo: Atención a clientes" />
            </Form.Item>
            <Form.Item
              name="action"
              label="Acción"
              rules={[
                { required: true, message: "Ingresa la acción asignada" }
              ]}
            >
              <Select
                style={{ width: "200px" }}
                placeholder="Selecciona primer nivel"
                onChange={onActionChange}
                options={[
                  { label: "Ninguna", value: "none" },
                  { label: "Transferir con Asesor", value: "transferToAgent" },
                  { label: "Cambiar Intención", value: "transferToIntent" },
                  { label: "Consultar Tabla", value: "searchTable" },
                  { label: "Finalizar", value: "fulfilIntent" }
                ]}
              />
            </Form.Item>
            {isIntentChange ? (
              <Form.Item
                name="intent"
                label="Intención"
                rules={[
                  {
                    required: true,
                    message: "Ingresa la intención a la que te quieres mover"
                  }
                ]}
              >
                <Select
                  style={{ width: "200px" }}
                  placeholder="Selecciona primer nivel"
                  options={[
                    { label: "Consulta de Ticket", value: "ConsultaTicket" }
                  ]}
                />
              </Form.Item>
            ) : null}
            {isFulfilment ? (
              <Form.Item
                name="message"
                label="Mensaje de cierre"
                rules={[
                  {
                    required: true,
                    message:
                      "Ingresa el mensaje con el que quieres cerrar la interacción"
                  }
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="ejemplo: Muchas gracias por su tiempo, nosotros le buscaremos."
                />
              </Form.Item>
            ) : null}
            {isSearchTable ? (
              <Form.Item
                name="table"
                label="Tabla"
                rules={[
                  {
                    required: true,
                    message: "Selecciona la tabla a consultar"
                  }
                ]}
              >
                <Select
                  style={{ width: "200px" }}
                  placeholder="Selecciona tabla"
                  options={[
                    {
                      label: "Rechazo comercial",
                      value: "InverTechBotCommercialRejection"
                    },
                    {
                      label: "Rechazo de servicio",
                      value: "InverTechBotServiceRejection"
                    }
                  ]}
                />
              </Form.Item>
            ) : null}
            <Form.Item
              name="model"
              label="Modelo"
              rules={[
                {
                  required: false,
                  message: "Ingresa el modelo para registrar el ticket"
                }
              ]}
            >
              <Input placeholder="ejemplo: SoporteRedes, Infraestructura, etc." />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default LevelTwo;
